module.exports = __webpack_public_path__ + "img/2_97.86650895.png";